export const EVENT_TYPE = {
    RACES: 1 as const,
    CHALLENGE: 2 as const,
    SWAG: 3 as const,
    EXERCISES: 4 as const
}

export enum EventType {
    Races = 'races',
    Store = 'store',
    Challenges = 'challenges',
    Exercises = 'exercises'
}
